const initializeCategorySwiper = () => {
  const categoriesSection = document.querySelector(".home-section-categories");
  if (!categoriesSection) return;

  const swiper = new Swiper(".home-section-categories .categories-swiper", {
    loop: false,
    slidesPerView: 1.25,
    spaceBetween: 16,
    breakpoints: {
      500: {
        slidesPerView: 2.25,
      },
      768: {
        slidesPerView: 3.25,
      },
      1200: {
        slidesPerView: 4.25,
      },
      1500: {
        slidesPerView: 5,
      },

    },
    navigation: {
      nextEl: ".home-section-categories .categories-swiper .swiper-button-next",
      prevEl: ".home-section-categories .categories-swiper .swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });
};

const initializeTopBannerSwiper = () => {
  const topBanner = document.querySelector(".home-section-banner");
  if (!topBanner) return;

  const swiper = new Swiper(".home-section-banner .banner-swiper", {
    direction: "horizontal",
    loop: true,
    autoplay: true,
    slidesPerView: "auto",
    delay: 5000,
    speed: 1000,
    navigation: {
      nextEl: ".home-section-banner .banner-swiper .swiper-button-next",
      prevEl: ".home-section-banner .banner-swiper .swiper-button-prev",
    },
  });
};

const initializeBrandSwiper = () => {
  const brandSection = document.querySelector(".home-section-brands");
  if (!brandSection) return;

  const swiper = new Swiper(".home-section-brands .brand-swiper", {
    direction: "horizontal",
    loop: true,
    autoplay: true,
    slidesPerView: 2,
    centeredSlides: true,
    speed: 1000,
    spaceBetween: 40,
    breakpoints: {
      500: {
        slidesPerView: 3,
      },
      650: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 6,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  });
};

function scrollToHelpCenterFAQs() {
  const faqElement = document.getElementById("helpCenterFAQs");

  if (faqElement) {
    const elementPosition = faqElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 80;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
}
const triggerUserway = () => {
  const userwayIcon = document.querySelector('#userwayAccessibilityIcon img');
  if (!userwayIcon) return;
  userwayIcon.click();
};

const accessibilityClickHandler = () => {
  const widgetButton = document.querySelector('#accessibilityWidget');
  if(!widgetButton) return;

  widgetButton.addEventListener('click', (e) => {
    e.preventDefault()
    triggerUserway();
  });
  widgetButton.addEventListener('keypress', (e) => {
    e.preventDefault()
    if (e.key === 'Enter') triggerUserway();
  });
};

const updateStoreLocationLinkText = () => {
  if(!document.body.classList.contains('page-contact-us')) return

  document.querySelectorAll('#intro h5 a').forEach((link) => {
    if (link.textContent == 'Store Locations and Directions') {
      link.textContent = 'Store Location and Directions';
      link.href = '/locations/furniture-warehouse'
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeCategorySwiper();
  initializeTopBannerSwiper();
  initializeBrandSwiper();
  accessibilityClickHandler();
  updateStoreLocationLinkText();
});
